import styled from "styled-components";
import { Text } from "../../../../base/Content";
import { DatePicker, CountrySelect, SimpleContextDropdown, DistributorSelect } from "../../../../form";
export const DeviceTrackingReportContainer = styled.div`
  margin-top: -30px;
`;

export const FilterLabel = styled(Text)``;

export const RangeStart = styled(DatePicker)``;
export const RangeEnd = styled(DatePicker)``;
export const Country = styled(CountrySelect)``;
export const Distributor = styled(DistributorSelect)``;
export const DeviceType = styled(SimpleContextDropdown)``;
export const Status = styled(SimpleContextDropdown)``;

//['program', 'status', 'lot', 'is_q_inside', 'is_tracked', 'not_blocked', 'is_registered'];
export const Error = styled(Text)`
  color: red;
  flex: 1 1 100%;
`;
